import React from 'react';
import { Input } from 'antd';

const CustomInputTypeNumber = (props) => {
  // eslint-disable-next-line
  return <Input type="number" {...props} style={{ width: 120, borderRadius: 20 }} onWheel={(e) => e.target.blur()} />;
};

export default CustomInputTypeNumber;
